.chatAndNavbar {
  display: flex;
  flex-direction: column;
}
.chatAndNavbar .chatNavbar {
  height: var(--navBarHeight);
  background-color: var(--navBarBackground);
  color: var(--navBarText);
  border-bottom: var(--outlineProperties);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0px;
}
.chatAndNavbar .chatNavbar .chatNavbarHeadingWrapper {
  width: 0;
  flex-grow: 1;
}
.chatAndNavbar .chatNavbar :global(.navbar-heading) {
  position: relative;
  width: fit-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding-inline-start: 5px;
  margin-inline-end: 0px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: bold;
  overflow: hidden;
}
.chatAndNavbar .chatNavbar :global(.navbar-heading) h1,
.chatAndNavbar .chatNavbar :global(.navbar-heading) h2,
.chatAndNavbar .chatNavbar :global(.navbar-heading) h3,
.chatAndNavbar .chatNavbar :global(.navbar-heading) h4,
.chatAndNavbar .chatNavbar :global(.navbar-heading) h5,
.chatAndNavbar .chatNavbar :global(.navbar-heading) h6 {
  font-size: inherit;
  font-weight: inherit;
  display: block;
  margin: 0;
}
.chatAndNavbar .chatNavbar :global(.navbar-heading-chat-info-button) {
  position: absolute;
  inset: 0;
  background-color: transparent;
  border: none;
}
.chatAndNavbar .chatNavbar :global(.views) {
  display: flex;
  align-items: center;
  min-height: 26px;
}
.chatAndNavbar .chatNavbar :global(.navbar-button) {
  padding: 0;
  width: 32px;
  height: 40px;
  margin-inline-start: calc((20px - 32px) / 2);
  margin-inline-end: calc(12px + (20px - 32px) / 2);
  border-radius: 0;
}
.chatAndNavbar .chatNavbar :global(.navbar-button):hover {
  background-color: var(--navBarButtonHover);
}
.chatAndNavbar .chatNavbar :global(#three-dot-menu-button) {
  height: 40px;
}

.webxdcIcons {
  line-height: 0;
  margin-right: 12px;
}
.webxdcIcons img.webxdcIcon {
  width: 25px;
  height: 25px;
  cursor: pointer;
  border-radius: 3px;
  background-color: #fff;
}

.webxdcIconButton {
  display: inline-block !important;
  margin: 0;
  margin-inline-end: 10px;
  padding: 0 !important;
  border-radius: 0 !important;
  line-height: 0;
}
.webxdcIconButton:last-child {
  margin-inline-end: 0;
}